import React from "react";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FormGroup, Button } from "react-bootstrap";

const MessageForm = (props) => {
    const validationSchema = Yup.object().shape({
        post: Yup.string().required("Required"),
    });
    console.log(props);
    return(
        <div className="form-wrapper">
            <Formik {...props} validationSchema={validationSchema}>
                <Form>
                    <FormGroup controlId="post">
                        <Field name="post" type="text"
                            className="form-control" />
                        <ErrorMessage
                            name="post"
                            className="d-block invalid-feedback"
                            component="span"
                        />
                    </FormGroup>
                    <Button variant="danger" size="lg"
                        block="block" type="submit">
                        {props.children}
                    </Button>
                </Form>
            </Formik>
        </div>
    );
};

export default MessageForm;